import React from "react";

import PropTypes from "prop-types";
import "./styles.scss";

const Chip = ({
  text,
  onClick,
  disabled,
  selected,
  key,
  animate,
  className,
}) => {
  return (
    <div
      key={key}
      onClick={onClick}
      className={`chip ${disabled && "chip-disabled"} ${
        selected && "chip-selected"
      } ${className}`}>
      <p className={`${animate && "fade-in-text"}`}>{text}</p>
    </div>
  );
};

Chip.propTypes = {
  text: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  key: PropTypes.string,
  animate: PropTypes.bool,
  className: PropTypes.string,
};

export default Chip;
